<div class="dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">新規サブステータス情報登録</h1>
    <span class="close" (click)="close()"></span>
  </div>
  <div class="dialog__body">
    <div class="dialog__contents">
      <ag-dynamic-form
        [metadata]="jobScreeningInfoMeta"
        [model]="jobScreeningInfoDataModel"
        *ngIf="jobScreeningInfoMeta && jobScreeningInfoDataModel"
      ></ag-dynamic-form>
    </div>
  </div>
  <div class="dialog__footer">
    <button class="dialog__button dialog__button--accent" (click)="close()">
      キャンセル
    </button>
    <button
      [disabled]="!isValidJobScreeningInfoData()"
      class="dialog__button dialog__button--primary"
      (click)="reflect()"
    >
      登録
    </button>
  </div>
</div>
